<app-side-menu>
  <div class="warehouse-form-content">
    <!-- Header -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center">
            <button 
              type="button"
              class="btn btn-outline-secondary me-3"
              (click)="cancel()">
              <i class="fas fa-arrow-left me-2"></i>
              Voltar
            </button>
            <div>
              <h1 class="page-title">
                <i class="fas fa-boxes-stacked me-3"></i>
                {{ warehouseId ? 'Editar Almoxarifado' : 'Novo Almoxarifado' }}
              </h1>
              <p class="page-subtitle">{{ warehouseId ? 'Atualize as informações do almoxarifado' : 'Cadastre um novo almoxarifado no sistema' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Formulário -->
    <div class="row">
      <div class="col-12">
        <div class="warehouse-form-card">
          <app-form-shell
            [tabs]="availableTabs"
            [activeTab]="activeTab"
            (tabChange)="selectTab($event)">
          </app-form-shell>

          <!-- Step 1: Identificação -->
          <div *ngIf="currentStep === 1" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-info-circle me-2"></i>
              Informações Básicas
            </h3>
            
            <div [formGroup]="formStep1" class="row g-3">
              <div class="col-md-3">
                <label for="code" class="form-label">Código *</label>
                <input 
                  type="text" 
                  id="code"
                  class="form-control"
                  formControlName="code"
                  [class.is-invalid]="isFieldInvalid('code')"
                  [class.is-valid]="code?.valid"
                  placeholder="Ex: ALM001">
                
                <div class="invalid-feedback" *ngIf="isFieldInvalid('code')">
                  {{ getFieldError('code') }}
                </div>
              </div>
              
              <div class="col-md-6">
                <label for="name" class="form-label">Nome *</label>
                <input 
                  type="text" 
                  id="name"
                  class="form-control"
                  formControlName="name"
                  [class.is-invalid]="isFieldInvalid('name')"
                  [class.is-valid]="name?.valid"
                  placeholder="Nome do almoxarifado">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('name')">
                  {{ getFieldError('name') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="type" class="form-label">Tipo *</label>
                <select 
                  id="type"
                  class="form-select"
                  formControlName="type"
                  [class.is-invalid]="isFieldInvalid('type')">
                  <option value="">Selecione...</option>
                  <option *ngFor="let type of warehouseTypes" [value]="type">{{ type }}</option>
                </select>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('type')">
                  {{ getFieldError('type') }}
                </div>
              </div>
              
              <div class="col-md-6">
                <label for="description" class="form-label">Descrição</label>
                <textarea 
                  id="description"
                  class="form-control" 
                  formControlName="description"
                  [class.is-invalid]="isFieldInvalid('description')"
                  rows="3"
                  placeholder="Descrição detalhada do almoxarifado..."></textarea>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('description')">
                  {{ getFieldError('description') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="category" class="form-label">Categoria</label>
                <select 
                  id="category"
                  class="form-select"
                  formControlName="category">
                  <option value="">Selecione...</option>
                  <option *ngFor="let category of warehouseCategories" [value]="category">{{ category }}</option>
                </select>
              </div>
              
              <div class="col-md-3">
                <label for="status" class="form-label">Status *</label>
                <select 
                  id="status"
                  class="form-select"
                  formControlName="status"
                  [class.is-invalid]="isFieldInvalid('status')">
                  <option *ngFor="let status of statusOptions" [value]="status.name">{{ status.name }}</option>
                </select>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('status')">
                  {{ getFieldError('status') }}
                </div>
              </div>
            </div>
          </div>

          <!-- Step 2: Localização & Responsável -->
          <div *ngIf="currentStep === 2" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-map-marker-alt me-2"></i>
              Localização
            </h3>
            
            <div [formGroup]="formStep2" class="row g-3">
              <div class="col-md-6">
                <label for="address" class="form-label">Endereço</label>
                <input 
                  type="text" 
                  id="address"
                  class="form-control"
                  formControlName="address"
                  [class.is-invalid]="isFieldInvalid('address')"
                  placeholder="Endereço completo">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('address')">
                  {{ getFieldError('address') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="city" class="form-label">Cidade</label>
                <input 
                  type="text" 
                  id="city"
                  class="form-control"
                  formControlName="city"
                  [class.is-invalid]="isFieldInvalid('city')"
                  placeholder="Cidade">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('city')">
                  {{ getFieldError('city') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="state" class="form-label">Estado</label>
                <input 
                  type="text" 
                  id="state"
                  class="form-control"
                  formControlName="state"
                  [class.is-invalid]="isFieldInvalid('state')"
                  placeholder="Estado">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('state')">
                  {{ getFieldError('state') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="zipCode" class="form-label">CEP</label>
                <input 
                  type="text" 
                  id="zipCode"
                  class="form-control"
                  formControlName="zipCode"
                  [class.is-invalid]="isFieldInvalid('zipCode')"
                  placeholder="00000-000"
                  (input)="onZipCodeInput($event)">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('zipCode')">
                  {{ getFieldError('zipCode') }}
                </div>
                <div class="mt-1">
                  <div *ngIf="isLoadingCep" class="d-flex align-items-center gap-2 text-primary">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <small>Buscando endereço...</small>
                  </div>
                  <div *ngIf="!isLoadingCep && cepError" class="text-danger">
                    <small>{{ cepError }}</small>
                  </div>
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="country" class="form-label">País</label>
                <input 
                  type="text" 
                  id="country"
                  class="form-control"
                  formControlName="country"
                  [class.is-invalid]="isFieldInvalid('country')"
                  placeholder="País">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('country')">
                  {{ getFieldError('country') }}
                </div>
              </div>
              
              <div class="col-md-2">
                <label for="building" class="form-label">Prédio</label>
                <input 
                  type="text" 
                  id="building"
                  class="form-control"
                  formControlName="building"
                  [class.is-invalid]="isFieldInvalid('building')"
                  placeholder="Prédio">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('building')">
                  {{ getFieldError('building') }}
                </div>
              </div>
              
              <div class="col-md-2">
                <label for="floor" class="form-label">Andar</label>
                <input 
                  type="text" 
                  id="floor"
                  class="form-control"
                  formControlName="floor"
                  [class.is-invalid]="isFieldInvalid('floor')"
                  placeholder="Andar">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('floor')">
                  {{ getFieldError('floor') }}
                </div>
              </div>
              
              <div class="col-md-2">
                <label for="room" class="form-label">Sala</label>
                <input 
                  type="text" 
                  id="room"
                  class="form-control"
                  formControlName="room"
                  [class.is-invalid]="isFieldInvalid('room')"
                  placeholder="Sala">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('room')">
                  {{ getFieldError('room') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="department" class="form-label">Departamento</label>
                <select 
                  id="department"
                  class="form-select"
                  formControlName="department">
                  <option value="">Selecione...</option>
                  <option *ngFor="let dept of departments" [value]="dept">{{ dept }}</option>
                </select>
              </div>
              
              <div class="col-md-3">
                <label for="branch" class="form-label">Filial</label>
                <select 
                  id="branch"
                  class="form-select"
                  formControlName="branch">
                  <option value="">Selecione...</option>
                  <option *ngFor="let branch of branches" [value]="branch">{{ branch }}</option>
                </select>
              </div>
            </div>

            <h3 class="section-title mt-4">
              <i class="fas fa-user me-2"></i>
              Responsável
            </h3>
            
            <div [formGroup]="formStep2" class="row g-3">
              <div class="col-md-6">
                <label for="managerStaffId" class="form-label">Funcionário Responsável *</label>
                <select
                  id="managerStaffId"
                  class="form-select"
                  formControlName="managerStaffId"
                  [class.is-invalid]="isFieldInvalid('managerStaffId')">
                  <option value="">Selecione um funcionário...</option>
                  <option *ngFor="let staff of staffMembers" [value]="staff.Id">
                    {{ staff.FullName }} ({{ staff.Registration }})
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('managerStaffId')">
                  {{ getFieldError('managerStaffId') }}
                </div>
              </div>

              <div class="col-md-6">
                <label for="responsiblePerson" class="form-label">Pessoa Responsável</label>
                <input 
                  type="text" 
                  id="responsiblePerson"
                  class="form-control"
                  formControlName="responsiblePerson"
                  [class.is-invalid]="isFieldInvalid('responsiblePerson')"
                  placeholder="Nome do responsável">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('responsiblePerson')">
                  {{ getFieldError('responsiblePerson') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="responsibleEmail" class="form-label">Email</label>
                <input 
                  type="email" 
                  id="responsibleEmail"
                  class="form-control"
                  formControlName="responsibleEmail"
                  [class.is-invalid]="isFieldInvalid('responsibleEmail')"
                  placeholder="email@exemplo.com">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('responsibleEmail')">
                  {{ getFieldError('responsibleEmail') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="responsiblePhone" class="form-label">Telefone</label>
                <input 
                  type="text" 
                  id="responsiblePhone"
                  class="form-control"
                  formControlName="responsiblePhone"
                  [class.is-invalid]="isFieldInvalid('responsiblePhone')"
                  placeholder="(11) 99999-9999"
                  (input)="onResponsiblePhoneInput($event)">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('responsiblePhone')">
                  {{ getFieldError('responsiblePhone') }}
                </div>
              </div>
            </div>
          </div>

          <!-- Step 3: Capacidade & Configurações -->
          <div *ngIf="currentStep === 3" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-chart-area me-2"></i>
              Capacidade
            </h3>
            
            <div [formGroup]="formStep3" class="row g-3">
              <div class="col-md-3">
                <label for="totalArea" class="form-label">Área Total (m²)</label>
                <input 
                  type="number" 
                  id="totalArea"
                  class="form-control"
                  formControlName="totalArea"
                  [class.is-invalid]="isFieldInvalid('totalArea')"
                  placeholder="0.00">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('totalArea')">
                  {{ getFieldError('totalArea') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="usedArea" class="form-label">Área Utilizada (m²)</label>
                <input 
                  type="number" 
                  id="usedArea"
                  class="form-control"
                  formControlName="usedArea"
                  [class.is-invalid]="isFieldInvalid('usedArea')"
                  placeholder="0.00">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('usedArea')">
                  {{ getFieldError('usedArea') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="availableArea" class="form-label">Área Disponível (m²)</label>
                <input 
                  type="number" 
                  id="availableArea"
                  class="form-control"
                  formControlName="availableArea"
                  [class.is-invalid]="isFieldInvalid('availableArea')"
                  placeholder="0.00">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('availableArea')">
                  {{ getFieldError('availableArea') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="maxCapacity" class="form-label">Capacidade Máxima</label>
                <input 
                  type="number" 
                  id="maxCapacity"
                  class="form-control"
                  formControlName="maxCapacity"
                  [class.is-invalid]="isFieldInvalid('maxCapacity')"
                  placeholder="0">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('maxCapacity')">
                  {{ getFieldError('maxCapacity') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="currentCapacity" class="form-label">Capacidade Atual</label>
                <input 
                  type="number" 
                  id="currentCapacity"
                  class="form-control"
                  formControlName="currentCapacity"
                  [class.is-invalid]="isFieldInvalid('currentCapacity')"
                  placeholder="0">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('currentCapacity')">
                  {{ getFieldError('currentCapacity') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="maxWeight" class="form-label">Peso Máximo (kg)</label>
                <input 
                  type="number" 
                  id="maxWeight"
                  class="form-control"
                  formControlName="maxWeight"
                  [class.is-invalid]="isFieldInvalid('maxWeight')"
                  placeholder="0.00">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('maxWeight')">
                  {{ getFieldError('maxWeight') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="currentWeight" class="form-label">Peso Atual (kg)</label>
                <input 
                  type="number" 
                  id="currentWeight"
                  class="form-control"
                  formControlName="currentWeight"
                  [class.is-invalid]="isFieldInvalid('currentWeight')"
                  placeholder="0.00">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('currentWeight')">
                  {{ getFieldError('currentWeight') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="startDate" class="form-label">Data de Início</label>
                <input 
                  type="date" 
                  id="startDate"
                  class="form-control"
                  formControlName="startDate">
              </div>
              
              <div class="col-md-3">
                <label for="endDate" class="form-label">Data de Fim</label>
                <input 
                  type="date" 
                  id="endDate"
                  class="form-control"
                  formControlName="endDate">
              </div>
            </div>

            <h3 class="section-title mt-4">
              <i class="fas fa-cogs me-2"></i>
              Configurações
            </h3>
            
            <div [formGroup]="formStep3" class="row g-3">
              <div class="col-md-6">
                <div class="form-check">
                  <input 
                    type="checkbox" 
                    id="isActive"
                    class="form-check-input" 
                    formControlName="isActive">
                  <label for="isActive" class="form-check-label">
                    <strong>Ativo</strong>
                  </label>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-check">
                  <input 
                    type="checkbox" 
                    id="isMainWarehouse"
                    class="form-check-input" 
                    formControlName="isMainWarehouse">
                  <label for="isMainWarehouse" class="form-check-label">
                    <strong>Almoxarifado Principal</strong>
                  </label>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-check">
                  <input 
                    type="checkbox" 
                    id="requiresAuthorization"
                    class="form-check-input" 
                    formControlName="requiresAuthorization">
                  <label for="requiresAuthorization" class="form-check-label">
                    <strong>Requer Autorização</strong>
                  </label>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-check">
                  <input 
                    type="checkbox" 
                    id="hasSecurity"
                    class="form-check-input" 
                    formControlName="hasSecurity">
                  <label for="hasSecurity" class="form-check-label">
                    <strong>Possui Segurança</strong>
                  </label>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-check">
                  <input 
                    type="checkbox" 
                    id="hasTemperatureControl"
                    class="form-check-input" 
                    formControlName="hasTemperatureControl">
                  <label for="hasTemperatureControl" class="form-check-label">
                    <strong>Controle de Temperatura</strong>
                  </label>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-check">
                  <input 
                    type="checkbox" 
                    id="hasHumidityControl"
                    class="form-check-input" 
                    formControlName="hasHumidityControl">
                  <label for="hasHumidityControl" class="form-check-label">
                    <strong>Controle de Umidade</strong>
                  </label>
                </div>
              </div>

              <div class="col-12">
                <label for="notes" class="form-label">Observações</label>
                <textarea 
                  id="notes"
                  class="form-control" 
                  formControlName="notes"
                  [class.is-invalid]="isFieldInvalid('notes')"
                  rows="4"
                  placeholder="Observações gerais sobre o almoxarifado..."></textarea>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('notes')">
                  {{ getFieldError('notes') }}
                </div>
              </div>
            </div>
          </div>

          <!-- Botões de Navegação -->
          <div class="form-actions">
            <div class="d-flex justify-content-between">
              <button 
                type="button"
                class="btn btn-outline-danger"
                (click)="cancel()">
                Cancelar
              </button>
              
              <div>
                <button 
                  type="button"
                  class="btn btn-outline-secondary me-2"
                  (click)="prevStep()"
                  [disabled]="currentStep === 1">
                  <i class="fas fa-arrow-left me-2"></i>
                  Anterior
                </button>
                
                <button 
                  type="button"
                  class="btn btn-primary me-2"
                  (click)="nextStep()"
                  *ngIf="currentStep < 3">
                  Próximo
                  <i class="fas fa-arrow-right ms-2"></i>
                </button>
                
                <button 
                  type="button"
                  class="btn btn-primary"
                  (click)="save()"
                  [disabled]="isSubmitting"
                  *ngIf="currentStep === 3">
                  <i class="fas fa-save me-2" *ngIf="!isSubmitting"></i>
                  <i class="fas fa-spinner fa-spin me-2" *ngIf="isSubmitting"></i>
                  {{ warehouseId ? 'Atualizar' : 'Salvar' }} Almoxarifado
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>
